import request from '@/utils/httpRequest'

// 场馆预订列表

export function getvenueList (query) {
  return request({
    url: 'api/onlinevenues/web/venuePage',
    method: 'get',
    params: query
  })
}

// 场馆详情
export function getvenueDetail (id) {
  return request({
    url: 'api/onlinevenues/web/venueDetails/' + id,
    method: 'get'
  })
}

// 获取时间api/onlinevenues/wt/time/{id}
export function getvenueTime (id) {
  return request({
    url: 'api/onlinevenues/wt/time/' + id,
    method: 'get'
  })
}
// 提交场馆预订的信息
export function getSubmit (query) {
  return request({
    url: 'api/onlinevenues/wt/venue/scheduled',
    method: 'post',
    data: query
  })
}

// 不可预订时间

export function nocanuse (query) {
  return request({
    url: 'api/onlinevenues/wt/time/notCanUse',
    method: 'get',
    params: query
  })
}

// 获取验证码

export function getVercode (time) {
  return request({
    url: 'api/auth/jwt/getCode?' + time,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/venue/index.js